/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect } from 'react';
import { Container, CssBaseline, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from '../../assets/styles/pages/Shops';
import Header from '../../components/Header';
import FooterMenuMain from '../../components/FooterMenuMain';
import SearchShops from '../../components/SearchShops';

import { ReactComponent as IconCategories } from '../../assets/images/svg/shops/icon_categoria.svg';

import { RootState } from '../../store';
import { actionListSegments } from '../../store/reduces/ReducerListSegments';

import { useLoadingContext } from '../../providers/use-loading';
import Darlings from '../../components/Darlings';
import Banners from '../../components/Banners';
import { ItypeReturnApi } from '../../helpers/utils/TypeReturnApi';
import { api } from '../../services';
import { useTrackingContext } from '../../context/TrackingContext';

const Segments: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { reducerListSegments } = useSelector((state: RootState) => state);
  const dispatch = useDispatch();
  const { createloading } = useLoadingContext();
  const { trackEvent } = useTrackingContext();

  const handleToPage = (url: string) => {
    return navigate(url);
  };

  const dataStorage = JSON.parse(
    localStorage.getItem('@mais/delivery/dataStateCity') as string,
  );

  const fetchIdsGoogleMeta = async (): Promise<any> => {
    try {
      const result: ItypeReturnApi =
        await api.apiMaisdelivery.shop.getMenuItensShop({
          nr_operacao: 80,
          idMarketplace: dataStorage?.idMarketplace,
        });

      localStorage.setItem(
        '@mais/delivery/dataStateCity/GA/GMT/PXL',
        JSON.stringify({
          ...result.data[0],
          execute: true,
        }),
      );
    } catch (error) {
      toast.error('Ocorreu um erro ao buscar os dados.');
    }
  };

  useEffect(() => {
    fetchIdsGoogleMeta();
  }, []);

  useEffect(() => {
    if (
      typeof dataStorage?.dsCidade !== 'undefined' &&
      reducerListSegments.data.length === 0
    ) {
      createloading(true);
      dispatch(
        actionListSegments.searchListSegments({
          nr_operacao: 18,
          dsCidade: dataStorage.dsCidade,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (!reducerListSegments.httprequest?.loading) {
      createloading(false);
      trackEvent('PageView');
    }
    if (reducerListSegments.httprequest?.error) {
      createloading(false);
      toast.error('Ocorreu um erro ao buscar os segmentos');
    }
  }, [reducerListSegments.httprequest]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Segments" />
      <CssBaseline />
      <SearchShops children={1} />
      <Banners />
      <Darlings />
      <Grid className={classeStyle.girdTitleSegments}>
        <IconCategories />
        <p className={classeStyle.textTitleSegments}>Segmentos</p>
      </Grid>
      <Grid
        container
        item
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        marginBottom="100px"
      >
        {reducerListSegments.data.length > 0 &&
          reducerListSegments.data.map((segment: any) => (
            <Grid
              container
              item
              justifyContent="center"
              alignItems="center"
              key={segment.idCategoria}
              className={classeStyle.gridMainSegments}
              onClick={() =>
                handleToPage(`list/shops/${window.btoa(segment.idCategoria)}`)
              }
            >
              <img
                src={`${process.env.REACT_APP_API_IMG}${segment.dsImagem}`}
                className={classeStyle.bannerMainSegments}
                alt="banner"
              />
            </Grid>
          ))}
      </Grid>
      <FooterMenuMain children="Shop" />
    </Container>
  );
};

export default Segments;
